(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  let contactOpened = false;

  function toggleContact() {
    document.getElementById('contactDropdown').classList.toggle('active');
  }

  window.addEventListener('scroll', () => {
    if (!contactOpened && window.scrollY > 400) {
      document.getElementById('contactDropdown').classList.add('active');
      contactOpened = true;
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
  const success = document.querySelector(".form-success");

  if (success) {
    setTimeout(() => {
      const target = document.getElementById("contact-success-anchor");

      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "end"
        });
      }
    }, 300);
  }

    const messageField = document.getElementById('ContactFormMessage');
    if (messageField) {
      const maxHeight = 100; // px, justera om du vill

      const autoResize = () => {
        messageField.style.height = '24px'; 
        const newHeight = Math.min(messageField.scrollHeight, maxHeight);
        messageField.style.height = newHeight + 'px';
      };

      messageField.addEventListener('input', autoResize);
      autoResize();
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const hamburger = document.querySelector('.hamburger');
  const nav = document.querySelector('.header-nav');
  const backdrop = document.querySelector('.menu-backdrop');
  const navLinks = document.querySelectorAll('.header-nav a');
  const header = document.querySelector('.custom-header');

  function updateHeader() {
    const threshold = window.innerHeight * 0.05;
    if (window.scrollY > threshold) {
      header.classList.add('header-scrolled');
    } else {
      header.classList.remove('header-scrolled');
    }
  }

  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader();

  function closeMenu() {
    hamburger.classList.remove('active');
    nav.classList.remove('active');
    backdrop.classList.remove('active');
  }

  if (hamburger) {
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('active');
      nav.classList.toggle('active');
      backdrop.classList.toggle('active');
    });
  }

  if (backdrop) {
    backdrop.addEventListener('click', closeMenu);
  }

  navLinks.forEach((link) => {
    link.addEventListener('click', closeMenu);
  });

   window.scrollToContact = function(e) {
    e.preventDefault();

    const dropdown = document.getElementById('contactDropdown');
    const target = document.getElementById('contact-section');

    if (!target) return;

    if (dropdown) {
      dropdown.classList.add('active');
    }

    setTimeout(() => {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 300);
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-fallskydd"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const video = document.querySelector(".hero-video");

  if (!video) return;

  video.addEventListener("loadeddata", function () {
    video.classList.add("is-loaded");
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ican-value"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll(".oican-value .reveal");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.15
    }
  );

  elements.forEach((el) => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oican-path"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll(
    ".oican-path .card, .oican-path .reveal"
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target;
        el.classList.add("is-visible");

        if (el.classList.contains("card")) {
          const items = el.querySelectorAll(".check-item");
          items.forEach((item, i) => {
            setTimeout(() => {
              item.classList.add("is-visible");
            }, i * 80);
          });
        }

        observer.unobserve(el);
      });
    },
    {
      threshold: 0.15
    }
  );

  elements.forEach((el) => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".partners-contact-section  .reveal:not(.duplicate)");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target;

        // base reveal
        el.classList.add("is-visible");

        // stagger logos
        if (el.classList.contains("partner-pill")) {
          const index = [...document.querySelectorAll(".partner-pill")].indexOf(el);
          el.style.transitionDelay = `${index * 0.08}s`;
        }

        observer.unobserve(el);
      });
    },
    {
      threshold: 0.2
    }
  );

  items.forEach((el) => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function () {
  const lineSegs = document.querySelectorAll('.line-seg');
  const cardOrder = [
    document.querySelector('.card-1'),
    document.querySelector('.card-2'),
    document.querySelector('.card-3'),
    document.querySelector('.card-4'),
  ];

  // Mät desktop-segment
  lineSegs.forEach(seg => {
    const len = seg.getTotalLength();
    seg.style.strokeDasharray = len;
    seg.style.strokeDashoffset = len;
  });

  // Mobillinje – isolerad
  setTimeout(() => {
    const mobilePath = document.querySelector('.line-seg-mobile-path');
    if (!mobilePath) return;
    const len = mobilePath.getTotalLength();
    mobilePath.style.strokeDasharray = len;
    mobilePath.style.strokeDashoffset = len;

    const mobileObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        setTimeout(() => {
          mobilePath.style.transition = 'stroke-dashoffset 6s cubic-bezier(0.4, 0, 0.2, 1)';
          mobilePath.style.strokeDashoffset = '0';
        }, 300);
        mobileObserver.disconnect();
      });
    }, { threshold: 0.05 });
    mobileObserver.observe(mobilePath.closest('svg'));
  }, 500);

  const isDesktop = window.innerWidth > 1200;

  if (isDesktop) {
    // DESKTOP – strikt 1→2→3→4
    let triggered = false;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting || triggered) return;
        if (!entry.target.classList.contains('process-card')) {
          entry.target.classList.add('is-visible');
          return;
        }
        triggered = true;
        cardOrder[0].classList.add('is-visible');
        setTimeout(() => { lineSegs[0]?.classList.add('is-visible'); }, 700);
        setTimeout(() => { cardOrder[1]?.classList.add('is-visible'); }, 750);
        setTimeout(() => { lineSegs[1]?.classList.add('is-visible'); }, 1700);
        setTimeout(() => { cardOrder[2]?.classList.add('is-visible'); }, 2000);
        setTimeout(() => { lineSegs[2]?.classList.add('is-visible'); }, 2700);
        setTimeout(() => { cardOrder[3]?.classList.add('is-visible'); }, 2800);
        observer.disconnect();
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.process-section .reveal:not(.process-card)').forEach(el => observer.observe(el));
    observer.observe(cardOrder[0]);

  } else {
    // MOBIL – varje kort triggas när det scrollas in
    cardOrder.forEach((card) => {
      if (!card) return;
      const obs = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          card.classList.add('is-visible');
          obs.unobserve(card);
        });
      }, { threshold: 0.25 });
      obs.observe(card);
    });

    // Reveal-text (eyebrow + rubrik)
    document.querySelectorAll('.process-section .reveal:not(.process-card)').forEach(el => {
      const obs = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          el.classList.add('is-visible');
          obs.unobserve(el);
        });
      }, { threshold: 0.1 });
      obs.observe(el);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teknologi-comparison"] && !Shopify.designMode) return;
  try {
    
  

  document.addEventListener('DOMContentLoaded', function () {
    const rows = document.querySelectorAll('.tech-compare table tr');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.2 }
    );

    rows.forEach((row) => observer.observe(row));
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teknologi-material"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.scroll-anim');
  if (!('IntersectionObserver' in window) || !elements.length) return;

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('scroll-anim--visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.15 }
  );

  elements.forEach(el => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unique"] && !Shopify.designMode) return;
  try {
    
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    },
    { threshold: 0.1 }
  );

  document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));

  } catch(e) { console.error(e); }
})();
})();
